import { createBrowserRouter } from "react-router-dom";
// auth
import ProtectRoutes from "./secureRouter";
// config
import appRoutes from "./appRoutes";
// pages
import App from "../App";
import ServiceMaintenance from "../pages/serviceMaintance";
import Logout from "../pages/logout";
import LayoutView from "../layout/layout";
// notification hooks
import CustomLogout from "../components/unauthorized/CustomLogout";
import UnAuthorizeRoutes from "./unauthorizedRouter";
import TenantSignup from "../components/unauthorized/tenant/Signup";
import OnSuccess from "../components/unauthorized/OnSuccess";
import VerifyEmailSuccess from "../components/unauthorized/VerifyEmailSuccess";
import CreateApp from "../components/unauthorized/OIDC/CreateApp";
import Signup from "../components/unauthorized/Signup";
import { TenantForgotPassword } from "../components/unauthorized/tenant/ForgotPassword";
import SingleFactorLogin from "../components/unauthorized/OIDC/SingleFactorLogin";
import TwoFactorLogin from "../components/unauthorized/OIDC/TwoFactorLogin";
import MfaCacheNotification from "../components/unauthorized/tenant/MfaCacheNotification";
import CreateNewUserTenant from "../components/userLogin/createNewUserTenant";
import Orglogin from "../components/unauthorized/Login";
import Login from "../pages/auth/login";
import EnrollPage from "../pages/enroll/EnrollPage";
import AuthenticatorSignInPage from "../pages/auth/AuthenticatorSignInPage";

const Apprender = () => {
  return (
    <>
      <App />
    </>
  );
};

const appChildren = [
  // 🌐 COMMON ROUTES (accessible for all)
  // Enrollment invite landing page. Common rather than under UnAuthorizeRoutes
  // on purpose: the recipient has no session (the token in ?d= is the
  // credential), but an admin who *does* have one must be able to open their own
  // invite link without being redirected away from it.
  { path: "enroll", element: <EnrollPage /> },
  // "Sign in to your organization" from the Authenticator app, in the phone's
  // browser. Common for the same reason as /enroll: it must work with or
  // without a console session. See pages/auth/authenticatorSignIn.js.
  { path: "authenticator/signin", element: <AuthenticatorSignInPage /> },
  { path: "logout", element: <Logout /> },
  { path: "custom/logout", element: <CustomLogout /> },
  { path: "service-maintenance", element: <ServiceMaintenance /> },
  {
    path: "tenant/*",
    children: [
      { path: "signup", element: <TenantSignup /> },
      { path: "login", element: <Login /> },
      { path: "forgot-password", element: <TenantForgotPassword /> },
    ],
  },
  {
    path: "register/*",
    children: [
      { path: "", element: <CreateNewUserTenant /> },
      { path: "app", element: <CreateApp /> },
    ],
  },
  // 🔓 UNAUTHORIZED ROUTES
  {
    element: <UnAuthorizeRoutes />,
    children: [
      {
        path: "org",
        children: [
          { path: "signup", element: <Signup /> },
          { path: "login", element: <Orglogin /> },
          { path: "success-signup", element: <OnSuccess /> },
          { path: "verify-email", element: <VerifyEmailSuccess /> },
        ],
      },
      {
        path: "oidc",
        children: [
          { path: "1fa", element: <SingleFactorLogin /> },
          { path: "2fa", element: <TwoFactorLogin /> },
        ],
      },
      { path: "sso-mfa", element: <MfaCacheNotification /> },
    ],
  },
  // 🔒 AUTHORIZED ROUTES
  {
    element: <ProtectRoutes />,
    children: [
      {
        element: <LayoutView />,
        children: appRoutes,
      },
    ],
  }
];

const rootRouter = createBrowserRouter([
  {
    path: "/",
    element: <Apprender />,
    children: appChildren,
  },
  {
    path: "/admin/*",
    element: <Apprender />,
    children: appChildren,
  },
]);

export default rootRouter;
